import React from 'react';
import { FiAlertTriangle, FiInbox, FiRefreshCw } from 'react-icons/fi';

export function CardSkeleton({ className = '', height = 96 }) {
  return (
    <div
      className={`animate-pulse rounded-xl border border-zinc-200 bg-white ${className}`}
      style={{ height }}
    >
      <div className="h-full w-full p-3">
        <div className="h-3 w-20 rounded bg-zinc-100" />
        <div className="mt-3 h-6 w-16 rounded bg-zinc-200" />
        <div className="mt-2 h-2 w-24 rounded bg-zinc-100" />
      </div>
    </div>
  );
}

export function RowSkeleton({ rows = 5 }) {
  return (
    <div className="space-y-2 p-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 rounded-lg border border-zinc-100 bg-white p-2">
          <div className="h-8 w-8 animate-pulse rounded-full bg-zinc-100" />
          <div className="flex-1 space-y-1.5">
            <div className="h-3 w-1/3 animate-pulse rounded bg-zinc-100" />
            <div className="h-2 w-1/2 animate-pulse rounded bg-zinc-100" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function EmptyState({ title = 'Nothing to show', description, action, icon: Icon = FiInbox }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-10 text-center">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-zinc-100 text-zinc-400">
        <Icon className="h-5 w-5" />
      </div>
      <div>
        <p className="text-sm font-semibold text-zinc-900">{title}</p>
        {description ? <p className="mt-0.5 text-xs text-zinc-500">{description}</p> : null}
      </div>
      {action}
    </div>
  );
}

export function ErrorState({ title = 'Something went wrong', description, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-10 text-center">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-red-50 text-red-500">
        <FiAlertTriangle className="h-5 w-5" />
      </div>
      <div>
        <p className="text-sm font-semibold text-zinc-900">{title}</p>
        {description ? <p className="mt-0.5 text-xs text-zinc-500">{description}</p> : null}
      </div>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 rounded-lg border border-zinc-200 bg-white px-3 py-1.5 text-xs font-medium text-zinc-700 hover:bg-zinc-50"
        >
          <FiRefreshCw className="h-3.5 w-3.5" />
          Retry
        </button>
      ) : null}
    </div>
  );
}

export function GapNotice({ label }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-md bg-amber-50 px-1.5 py-0.5 text-[10px] font-medium text-amber-700 ring-1 ring-amber-200">
      {label}
    </span>
  );
}
